// FILE: src/Components/Social Desings/InstagarmModal.js

import React, { useState, useRef } from 'react';
import { Carousel, Skeleton, Button } from 'antd';
import Images from '../../Comman Components/Images';
import UserName from '../../Comman Components/UserName';
import moment from 'moment';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import defaultPreviewPlaceholder from '../../Assets/dummy_images/default-preview-placeholder.webp';
const PrevArrow = ({ onClick }) => (
    <Button shape="circle" icon={<LeftOutlined />} onClick={onClick} className="absolute left-2 top-1/2 z-10 -translate-y-1/2 bg-white/70 hover:bg-white" />
);

const NextArrow = ({ onClick }) => (
    <Button shape="circle" icon={<RightOutlined />} onClick={onClick} className="absolute right-2 top-1/2 z-10 -translate-y-1/2 bg-white/70 hover:bg-white" />
);

export default function InstagarmModal({ Previewimages: mediaItems = [], Previewcaptions = '', profile, instagramOptions }) {
    const [open, setOpen] = useState(true);
    const carouselRef = useRef();

    const renderMedia = () => {
       if (!mediaItems || mediaItems.length === 0) {
  return (
    <img
      src={defaultPreviewPlaceholder}
      alt="Default preview"
      className="w-full h-auto max-h-96 object-cover"
    />
  );
}
        
        const renderSingleItem = (item) => {
            const urlToRender = item.permanentUrl || item.localUrl;

            return item.type === 'video'
                ? <video src={urlToRender} controls className="w-full h-auto max-h-96 object-contain bg-black" />
                : <img src={urlToRender} className="w-full h-auto max-h-96 object-cover" alt="Post preview" />;
        };

        if (mediaItems.length === 1) {
            return renderSingleItem(mediaItems[0]);
        }

        return (
            <Carousel ref={carouselRef} arrows prevArrow={<PrevArrow />} nextArrow={<NextArrow />}>
                {mediaItems.map((item, index) => (
                    <div key={index}>
                        {renderSingleItem(item)}
                    </div>
                ))}
            </Carousel>
        );
    };

    return (
        <div className="w-full max-w-sm mx-auto my-4 border border-gray-300 rounded-xl">
            <button onClick={() => setOpen(!open)} className="w-full flex items-center justify-between p-3 font-semibold text-left">
                <div className="flex items-center gap-2">
                    <i className="fa-brands fa-instagram text-pink-500 text-lg"></i>
                    <span>Instagram</span>
                </div>
                <i className={`fa ${open ? "fa-angle-up" : "fa-angle-down"} text-gray-400`}></i>
            </button>

            {open && (
                <div className="border-t border-gray-200">
                    <header className="flex items-center p-3 gap-3">
                        {profile ? <Images Id={profile.platform_id} /> : <Skeleton.Avatar active size="small" shape="circle" />}
                        <div className="font-semibold text-sm">
                            {profile ? <UserName Id={profile.platform_id} /> : <Skeleton.Input style={{ width: 120, height: 16 }} active size="small" />}
                        </div>
                    </header>

                    <div className="bg-black relative">
                        {renderMedia()}
                    </div>

                    <footer className="p-3 space-y-2">
                        <div className="flex items-center text-2xl gap-4 text-gray-700">
                            <i className="fa-regular fa-heart"></i>
                            <i className="fa-regular fa-comment"></i>
                            <i className="fa-regular fa-paper-plane"></i>
                        </div>
                        <p className="text-sm whitespace-pre-wrap">
                            <b className="mr-1">{profile ? <UserName Id={profile.platform_id} /> : "username"}</b>
                            {Previewcaptions || <span className="text-gray-400 italic">The main caption will appear here...</span>}
                        </p>
                        {instagramOptions?.firstComment && (
                             <p className="text-sm text-gray-700 pt-1">
                                <b className="mr-1">{profile ? <UserName Id={profile.platform_id} /> : "username"}</b>
                                {instagramOptions.firstComment}
                            </p>
                        )}
                        <p className="text-xs text-gray-400 uppercase">
                            {moment().format('MMMM D')}
                        </p>
                    </footer>
                </div>
            )}
        </div>
    );
}